import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { getSliders } from '../../Data';
import { Global } from '../../Variables/Global';

const Slider = () => {
    SwiperCore.use([Autoplay, Pagination, Navigation]);
    const [sliders, setSliders] = useState([]);



    
    useEffect(() => {
        getSliders(2).then((result) => {
            setSliders(result[0].slides);
        })
    },[])
    return (
        <>
            <div className='mainSlider'>
                <Swiper modules={[Pagination]} 
                    pagination={{ clickable: true }} 
                    className='mainSlider' spaceBetween={50} slidesPerView={1}
                    autoplay={{
                        "delay": 4000,
                        "disableOnInteraction": false
                    }}
                    style={{ zIndex: '9'}}
                    >
                        {
                            sliders.map((slide,index) => {
                                return (
                                    <SwiperSlide key={index}>
                                    <div style={{ position: 'relative' }}>
                                        <img src={Global.PHOTO_URL + slide.SlideImage} />
                                        <a href="/Shop" className="slider-button RemUnderline">SHOP NOW</a>
                                    </div>
                                </SwiperSlide>
                                )
                            })
                        }
                    {/* <SwiperSlide key={1}>
                        <div style={{ position: 'relative' }}>
                            <img src="/assets/images/sliders/SLIDER 1.jpg" />
                            <a href="shop-left-sidebar.html" className="slider-button RemUnderline">SHOP NOW</a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide key={2}>
                        <div style={{ position: 'relative' }}>
                            <img src="/assets/images/sliders/SLIDER 2.jpg" />
                            <a href="shop-left-sidebar.html" className="slider-button RemUnderline">SHOP NOW</a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide key={3}>
                        <div style={{ position: 'relative' }}>
                            <img src="/assets/images/sliders/SLIDER 3.jpg" />
                            <a href="shop-left-sidebar.html" className="slider-button RemUnderline">SHOP NOW</a>
                        </div>
                    </SwiperSlide> */}
                </Swiper>

            </div>
        </>
    )
}

export default Slider